<template>
  <div>
  <!-- Questa vista serve solo come base per visualizzare poi i due components    -->
  <!-- i quali visualizzano o la pagina come Welfare di Marca ( vendita voucher ) -->
  <!-- o come Ollipay Standard in base al profilo con il quale l'utente è stato   -->
  <!-- registrato.                                                                -->
  <!-- Avvia la pagina come Welfare di Marca -->
  <OlliPayWfm v-if="is_wfm"/>
  <!-- Avvia la pagina come Ollipay Standard -->
  <OlliPayStd v-else />
  </div>
</template>

<script>

import OlliPayWfm from '@/components/ollipay/OlliPayWfm'
import OlliPayStd from '@/components/ollipay/OlliPayStd'

export default {
  name: 'OlliPay',
  data () {
    return {}
  },
  computed :{
    /**
     * Una computed che ci dice se per Ollipay abbiamo il welfare di marca o meno
     * di modo tale da semplificare l'if del rendering della pagina.
     * Qui non controlliamo lo stato di registrazione perchè non si arriva mai a questa
     * pagina se non si è registrati. Infatti in caso di mancata registrazione oltre
     * a non vedere la voca di menù il router ci rimanda alla home.
     */
    is_wfm : function () {
        return this.$store.state.user.ollipay_status.profile === 'wfm' ? true : false;
    }
  },
  components: {
    OlliPayWfm,
    OlliPayStd
  }
}
</script>

<style scoped></style>